<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="heading-large mt-0">Upload Pricing Matrix</h1>
                    <button type="button" class="modal-close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    
                    <div class="text-danger">
                        <p>
                            Please be aware: This action will overwrite any costs you have previously entered. Are you sure you want to continue?
                        </p>
                    </div>
                    <div>
                        <b>{{lastUploadTime }}</b>
                    </div>
                     <div>
                        <b>{{lastUploadFile}}</b>
                    </div>
                    <div class="row chooseFileButton mt-4">
                        <form class="form-group d-flex flex-row col-12" id='fileForm'>
                            <label for="file" class="mr-2 mt-2">File name</label>
                            <input type="file" class="bg-olf-light-greyish-blue p-2" accept=".csv" id="file" @change="processFile($event)" name="file"/>
                        </form>
                    </div>
                </div>
                <div class="modal-footer d-flex flex-column justify-content-center">
                    <div class="d-block text-danger mb-3" :class="messageType">
                        <b>{{message}}</b>
                    </div>
                    <button v-if="messageType === 'hidden'|| messageType === 'loading' || messageType === 'error'" class="btn btn-secondary" @click="upload()" :disabled="uploadDisabled">Upload</button>
                    <button v-else class="btn btn-tertiary" data-dismiss="modal" aria-label="Close" @click="closeModal()" >Close</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import {mapState,mapActions} from 'vuex';

export default {
    data: function(){
        return{
            messageType:"hidden",
            message:"",
            uploadDisabled:true,
            inputValue:"",
            lastUploadTime:"",
            lastUploadFile: ''
        }
    },
    created(){
        this.getDinTerminals(),
        this.getLastUploadTimeAndFileName()
    },
    computed:{
        ...mapState('sellerOffers',['newOffers','filteredOffers']),
        ...mapState('login',['userLoggedIn'])
    },
    methods:{
        ...mapActions('sellerOffers',['closeUploadMatrixModal', 'getDinTerminals']),
        getLastUploadTimeAndFileName:  async function(){
            const moment = require('moment');
            let response
            try{
                response = await this.axios.get('/api/haulage', {params: {accountId: this.userLoggedIn.id}})
                let time = response.data.payload.latestFile.created
                time = moment(time).format("dddd, MMMM Do YYYY, h:mm:ss a")
                let timeText = "Last file's uploaded at:  "  + time 
                this.lastUploadTime  = timeText
                let fileName = response.data.payload.latestFile.fileName
                let fileNameText = "Last file's name:  "  + fileName 
                this.lastUploadFile  = fileNameText
            }catch(ex){
                this.lastUploadTime  = " "
                this.lastUploadFile  = " "
                console.log(ex)
            }
        },
        processFile(event) {
            this.inputValue = event.target.files[0]
            if(this.inputValue){
                this.uploadDisabled = false
            }else {
                this.uploadDisabled = true
            }
        },
        upload: async function(){
            this.messageType = "loading"
            this.message = "Uploading file, please wait..."
            this.uploadDisabled = true
            var form = document.getElementById('fileForm')
            var formData = new FormData(form);
            formData.set('accountId', this.userLoggedIn.id)
            formData.set('userId', this.userLoggedIn.userId);
            
            try {
                const response = await this.axios.post('/api/haulage', formData, { headers: {'Content-Type': 'multipart/form-data' }})
                
                if (response.data.success){
                    this.messageType = "success"
                    this.message = "File has been uploaded."  
                    this.getDinTerminals()
                    this.getLastUploadTimeAndFileName()
                }
                else {
                    this.messageType = "error"
                    this.message = "There is an error uploading this file, please try again."
                    this.uploadDisabled = false
                }
            }
            catch (ex) {
                if (!ex.response.data.success) {
                    this.messageType = "error"
                    this.message = "There is an error uploading this file, please try again."
                    this.uploadDisabled = false
                }
            }
        },
        closeModal(){
            $(this.$el).modal("hide");
            this.closeUploadMatrixModal()
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>